var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",staticClass:"icon-with-text"},[_c('a-icon',_vm._b({staticClass:"icon-with-text__icon"},'a-icon',( _obj = {}, _obj[_vm.icon ? 'type' : 'component'] = _vm.icon || _vm.component, _obj ),false)),_c('div',{staticClass:"icon-with-text__content"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }